import { Box, Skeleton } from '@mui/material';

function InsightSkeleton() {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.palette.custom.white,
        padding: 2,
        boxShadow: `0 4px 24px ${theme.palette.custom.boxShadow}`,
        mb: 1,
        borderRadius: '8px',
      })}
    >
      <Skeleton variant="text" width="70%" height={25} />
    </Box>
  );
}

export default InsightSkeleton;
